export const API_PATH_ApiDeviceMgmtRegionDeviceStatusGet = '/services/devices-mgtm/apiDeviceMgmtRegionDeviceStatusGet';
